<div class="fee-distribution-chart" *ngIf="mempoolVsizeFeesOptions && stateService.isBrowser; else loadingFees">
  <div *browserOnly echarts [initOpts]="mempoolVsizeFeesInitOptions" [options]="mempoolVsizeFeesOptions"></div>
</div>

<ng-template #loadingFees>
  <div class="text-center">
    <div class="spinner-border text-light"></div>
  </div>
</ng-template>
